import { useNavigate } from "react-router-dom";
import "./../../styles/NaoAutorizado.css";
import { Lock } from "lucide-react";
import { useEffect } from "react";
import { useSessionExpirationCheck } from "../../hooks/useSessionExpirationCheck";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";

const Unauthorized = () => {
  const token = useSelector((state: RootState) => state.auth.token);
  const sessionExpiration = useSelector(
    (state: RootState) => state.auth.SessionExpiration
  );
  const navigate = useNavigate();

  useSessionExpirationCheck(sessionExpiration, token);

  useEffect(() => {
    document.title = "Íkone | Acesso Negado";
  }, []);

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        <Lock className="unauthorized-icon" size={48} />
        <h1 className="unauthorized-title">Acesso Negado</h1>
        <p className="unauthorized-message">
          Você não tem permissão para acessar esta página.
        </p>
        <button className="unauthorized-button" onClick={() => navigate("/")}>
          Voltar para a Home
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
